module.exports = __webpack_public_path__ + "img/gender.bb3b30a3.svg";